import {AuthProvider, CheckResponse, OnErrorResponse} from '@refinedev/core';
import {apiService} from '../ApiService';
import useLoginStore from '@/store/useLoginStore';
import useAbilityStore, {getAbilityFromUserdata} from '@/store/useAbilityStore';

const auth_type: 'cookie-based' | 'token-based' = (import.meta.env.PROD || location.hostname!=='localhost')
  ? 'cookie-based'
  : 'token-based';
console.log('auth-type',auth_type);

export const authProvider: AuthProvider = {
  login: async ({username, password}) => {
    try {
      console.log('login', username);
      let data: any = undefined;
      if (auth_type === 'token-based') {
        data = await apiService.auth.loginToken(username, password); //do login and get token
        localStorage.setItem('token', data.token);
        apiService.setToken(data.token);
      } else {
        data = await apiService.auth.login(username, password); //do login cookie based
      }
      const userdata = await apiService.auth.currentUser(); // get user role, permission, and others
      useLoginStore.setState({isLoggedIn: true, userdata: userdata});
      const ability = getAbilityFromUserdata(userdata);
      useAbilityStore.setState({ability});

      return {
        success: true,
        userdata: userdata,
        redirectTo: '/',
      };
    } catch (error: any) {
      return {
        success: false,
        error: error.message,
      };
    }
  },
  logout: async () => {
    try {
      console.log('logout');
      if (auth_type === 'token-based') {
        await apiService.auth.logoutToken();
        localStorage.removeItem('token');
        apiService.setToken(undefined);
      } else {
        const resp = await apiService.auth.logout();
      }
      useLoginStore.setState({isLoggedIn: false, userdata: undefined});
      useAbilityStore.setState({ability: undefined});
      return {success: true, redirectTo: '/auth/login'};
    } catch (error: any) {
      return {success: false, error: error.message};
    }
  },

  check: async function (params?: any): Promise<CheckResponse> {
    try {
      // Implement checkAuth logic here (e.g., call a protected API endpoint)
      const {ability} = useAbilityStore.getState();
      if (!ability) {
        console.log('Ability NOT available, check with server');
        // token-based ? set token
        if (auth_type === 'token-based') {
          const token = localStorage.getItem('token');
          if (!token) {
            console.log('Token not available');
            return {authenticated: false, logout: true, redirectTo: '/auth/login'};
          }
          apiService.setToken(token);
        }
        const userdata = await apiService.auth.currentUser();
        useLoginStore.setState({isLoggedIn: true, userdata: userdata});
        const ability = getAbilityFromUserdata(userdata);
        useAbilityStore.setState({ability});
        console.log('Check ok');
      } else console.log('Ability available, user authenticated', ability);
      return {authenticated: true};
    } catch (error: any) {
      console.log('Check auth failed', error);
      return {authenticated: false, logout: true, error: error.message, redirectTo: '/auth/login'};
    }
  },
  onError: async function (error): Promise<OnErrorResponse> {
    console.log('Error', error);
    if (error?.status === 401)
      return {
        error: error?.data?.message,
        logout: true,
        redirectTo: '/auth/login',
      };
    else if (error?.status === 403)
      return {
        error: error?.data?.message,
      };

    return {};
  },

  getIdentity: async () => {
    try {
      console.log('getIdentity');
      // Implement checkAuth logic here (e.g., call a protected API endpoint)
      const response = await apiService.auth.currentUser();
      return {success: true, userdata: response};
    } catch (error: any) {
      return {success: false, error: error.message};
    }
  },
};
